import { render, staticRenderFns } from "./payoutPartner.vue?vue&type=template&id=04ea0c46&scoped=true"
import script from "./payoutPartner.vue?vue&type=script&lang=js"
export * from "./payoutPartner.vue?vue&type=script&lang=js"
import style0 from "./payoutPartner.vue?vue&type=style&index=0&id=04ea0c46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ea0c46",
  null
  
)

export default component.exports